import { z } from 'zod'

export const passwordSchema = z
  .string()
  .min(1, 'Password is required')
  .min(8, 'Password must be at least 8 characters')
  .max(72, 'Password must be less than 72 characters')
  .refine(
    (pwd) => !/(.)\1{4,}/.test(pwd),
    'Password cannot contain too many repeated characters'
  )

/**
 * Password confirmation schema with password matching validation.
 * Extend with additional fields as needed using `.extend()`.
 *
 * @example
 * // Basic usage (reset password)
 * const formSchema = passwordFieldsSchema
 *
 * @example
 * // With additional fields (settings password change)
 * const formSchema = passwordFieldsSchema.extend({
 *   currentPassword: z.string().min(1, 'Current password is required')
 * })
 */
export const passwordFieldsSchema = z
  .object({
    password: passwordSchema,
    confirmPassword: z.string().min(1, 'Please confirm your password'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ['confirmPassword'],
  })
